module.exports = __webpack_public_path__ + "static/media/2.95851223.jpg";